import {
  FETCH_USERS_DATA_FAILURE,
  FETCH_USERS_DATA_SUCCESS,
  FETCH_USERS_DATA,
  FETCH_USERS_DATA_MORE_SUCCESS,
  FETCH_USERS_DATA_MORE_FAILURE,
  FETCH_USERS_DATA_MORE,
} from "../actions";

const initialState = {
  usersData: [],
  loading: true,
  err: null,
  haveData: false,
  userDataNext: null,
  moreLoading: false,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USERS_DATA:
      return {
        ...state,
        loading: true,
        err: null,
        haveData: false,
      };
    case FETCH_USERS_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        haveData: true,
        usersData: action.data.data,
        userDataNext: action.data.next,
      };
    case FETCH_USERS_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        haveData: false,
        err: true,
        usersData: [],
      };
    case FETCH_USERS_DATA_MORE:
      return {
        ...state,
        loading: false,
        moreLoading: true,
      };

    case FETCH_USERS_DATA_MORE_SUCCESS:
      return {
        loading: false,
        moreLoading: false,
        haveData: true,
        usersData: [...state.usersData, ...action.data.data],
        userDataNext: action.data.next ? action.data.next : null,
      };
    default:
      return state;
  }
};
